module.exports = __webpack_public_path__ + "static/media/iron.ac521a28.png";